import $i18n from 'panda-i18n';
import React, { forwardRef, useImperativeHandle, useRef, useState, } from 'react';
import classNames from 'classnames';
import { withNativeProps } from '@/utils/with-native-props';
import { usePropsValue } from '@/utils/use-props-value';
import { CnInput } from '../cn-input';
import { CnButton } from '../cn-button';
import { CnIcon } from '../cn-icon';
const classPrefix = 'cn-ui-m-search';
const Search = (props, ref) => {
    const { showCancelMode, clearOnCancel, icon, loading, cancelText = $i18n.get({ id: 'Cancel', dm: '取消', ns: 'CnSearch' }), placeholder = $i18n.get({
        id: 'PleaseEnterTheSearchContent',
        dm: '请输入搜索内容',
        ns: 'CnSearch',
    }), } = props;
    const [value, setValue] = usePropsValue(props);
    const [hasFocus, setHasFocus] = useState(false);
    const inputRef = useRef(null);
    const composingRef = useRef(false);
    useImperativeHandle(ref, () => ({
        clear: () => inputRef.current?.clear(),
        focus: () => inputRef.current?.focus(),
        blur: () => inputRef.current?.blur(),
        get nativeElement() {
            return inputRef.current?.nativeElement ?? null;
        },
    }));
    const renderCancelButton = () => {
        let isShowCancel;
        if (showCancelMode === 'always') {
            isShowCancel = true;
        }
        else {
            isShowCancel = showCancelMode === 'focus' && hasFocus;
        }
        return (isShowCancel && (React.createElement("div", { className: `${classPrefix}-suffix` },
            React.createElement(CnButton, { text: true, type: "primary", className: `${classPrefix}-cancel-button`, onClick: () => {
                    if (clearOnCancel) {
                        inputRef.current?.clear();
                        setValue('');
                    }
                    inputRef.current?.blur();
                    props.onCancel?.();
                }, onMouseDown: (e) => {
                    e.preventDefault();
                } }, cancelText))));
    };
    const handleKeydown = (e) => {
        if (e.code === 'Enter' || e.keyCode === 13) {
            if (!composingRef.current) {
                inputRef.current?.blur();
                props.onSearch?.(value);
            }
        }
    };
    return withNativeProps(props, React.createElement("div", { className: classNames(classPrefix, {
            [`${classPrefix}-active`]: hasFocus,
        }) },
        React.createElement("div", { className: `${classPrefix}-input-box` },
            icon && React.createElement("div", { className: `${classPrefix}-input-box-icon` }, icon),
            React.createElement(CnInput, { ref: inputRef, confirmType: "search", 
                // type="search" 时 hover 时会出现 X
                // htmlType="search"
                enterKeyHint: "search", composition: true, className: classNames(`${classPrefix}-input`, {
                    [`${classPrefix}-input-without-icon`]: !icon,
                }), value: value, onChange: setValue, maxLength: props.maxLength, placeholder: placeholder, hasClear: loading ? false : props.hasClear, state: loading ? 'loading' : 'normal', onFocus: (e) => {
                    setHasFocus(true);
                    props.onFocus?.(e);
                }, onBlur: (e) => {
                    setHasFocus(false);
                    props.onBlur?.(e);
                }, onClear: props.onClear, onKeyDown: handleKeydown, type: "normal", onCompositionStart: () => {
                    composingRef.current = true;
                }, onCompositionEnd: () => {
                    composingRef.current = false;
                } })),
        renderCancelButton()));
};
const CnSearch = forwardRef(Search);
CnSearch.displayName = 'CnSearch';
CnSearch.defaultProps = {
    showCancelMode: 'none',
    clearOnCancel: true,
    icon: React.createElement(CnIcon, { type: "search" }),
};
export { CnSearch };
